"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getResults = getResults;
exports.questions = void 0;

var _sum2 = _interopRequireDefault(require("lodash/sum"));

var _utils = require("./utils");

var _howOften = _interopRequireDefault(require("../options/howOften"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var batteryId = _utils.screeners.PHQ9;
var baseProps = {
  batteryId: batteryId,
  aggregated: true,
  type: "multi",
  extraText: "Over the last 2 weeks, how often have you been bothered by any of the following problems",
  options: _howOften["default"]
};
var phqQuestions = [{
  prompt: "Little interest or pleasure in doing things?"
}, {
  prompt: "Feeling down, depressed, or hopeless?"
}, {
  prompt: "Trouble falling or staying asleep, or sleeping too much?"
}, {
  prompt: "Feeling tired or having little energy?"
}, {
  prompt: "Poor appetite or overeating?"
}, {
  prompt: "Feeling bad about yourself — or that you are a failure or have let yourself or your family down ?"
}, {
  prompt: "Trouble concentrating on things, such as reading the newspaper or watching television ?"
}, {
  prompt: "Moving or speaking so slowly that other people could have noticed? Or the opposite — being so fidgety or restless that you have been moving around a lot more than usual  ?"
}, {
  prompt: "Thoughts that you would be better off dead or of hurting yourself in some way?"
}];
var questions = (0, _utils.wrapBattery)(phqQuestions, baseProps);
exports.questions = questions;

function getResults(answers) {
  var score = Math.round((0, _sum2["default"])(answers));
  return {
    PHQ9: score,
    PHQ_1: answers[0],
    PHQ_2: answers[1],
    PHQ_3: answers[2],
    PHQ_4: answers[3],
    PHQ_5: answers[4],
    PHQ_6: answers[5],
    PHQ_7: answers[6],
    PHQ_8: answers[7],
    PHQ_9: answers[8]
  };
}